// extracted by css-extract-rspack-plugin
export default {"suppressOutline":"_3aab9f2a"};